import { getImmutableCompatible } from 'src/utils/immutableUtils';
import type { SupplierFieldsProps } from '../../../../../types/supplierFieldsTypes';
import { name } from './slice';

export const getSupplierFieldsData = (state): SupplierFieldsProps[] =>
  getImmutableCompatible(state, name);
